var map = {
	"./bao.gif": "f5f2",
	"./chicken-hero.gif": "9da1",
	"./chicken.gif": "7221",
	"./co-branding-logos-secondary.gif": "ad3e",
	"./co-branding-tab.gif": "9061",
	"./co-branding-world-JET-1.gif": "164a",
	"./co-branding-world-JET-2.gif": "984c",
	"./co-branding-world-JET-3.gif": "245d",
	"./co-branding-world-RP-1.gif": "6394",
	"./colour-how-much-orange.gif": "a99f",
	"./composition-cards-animation.gif": "3a53",
	"./composition-grid-animation.gif": "5b86",
	"./composition-razor-animation.gif": "398c",
	"./edamame.gif": "ecb4",
	"./icecream.gif": "7212",
	"./illustration-categories-1-mobile.gif": "e405",
	"./illustration-categories-2-mobile.gif": "dfbd",
	"./illustration-categories-3-mobile.gif": "cead",
	"./illustration-categories.gif": "6c6d",
	"./loading-circles.gif": "de0a",
	"./logo-gif-global-corporate.gif": "4c72",
	"./logo-gif-markets.gif": "6e75",
	"./logo-gif-sub-brands-products.gif": "c882",
	"./photo-studio-art-direction.gif": "7817",
	"./photo-studio-carousel.gif": "8b1b",
	"./resto-world-gif.gif": "2f6c",
	"./typography-alignment.gif": "8957"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc6d";